import ExtendedSchedulerContainer from './components/ExtendedSchedulerContainer';
import ExtendedSchedulerProviderFilterPanel from './components/ExtendedSchedulerProviderFilterPanel';
import ExtendedSchedulerAvailabilitiesList from './components/ExtendedSchedulerAvailabilitiesList';

const ExtendedScheduler = {
  AvailabilitiesList: ExtendedSchedulerAvailabilitiesList,
  Container: ExtendedSchedulerContainer,
  ProviderFilterPanel: ExtendedSchedulerProviderFilterPanel,
};

export default ExtendedScheduler;
